import Footer from "../../common/footer/footer.tsx";
import "./termsAndCondition.css";

const TermsAndCondition = () => {
  return (
    <>
      <div className='terms-container'>
        <div className='terms-card'>
          <h1 className='terms-title'>Terms & Conditions</h1>

          <p className='terms-subtitle'>
            <strong>Uyirthunai</strong> <br />
          </p>

          <p className='terms-intro'>
            Welcome to Uyirthunai, Sri Lanka's trusted matrimonial platform. By accessing or using our website and
            services, you agree to be bound by the following Terms & Conditions. Please read them carefully before
            proceeding.
          </p>

          <div className='terms-section'>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing, registering, or using Uyirthunai, you confirm that you have read, understood, and agree to
              be bound by these Terms & Conditions and all applicable laws and regulations of Sri Lanka.
            </p>
          </div>

          <div className='terms-section'>
            <h2>2. Eligibility</h2>
            <p>
              You must be at least 18 years of age to register and use our services. By creating an account, you
              represent and warrant that you meet this age requirement and have the legal capacity to enter into this
              agreement. Uyirthunai reserves the right to terminate any account found to be in violation of this
              requirement.
            </p>
          </div>

          <div className='terms-section'>
            <h2>3. Account Registration</h2>
            <p>
              You agree to provide accurate, truthful, current, and complete information at the time of registration and
              to keep your account information updated at all times. You are solely responsible for maintaining the
              confidentiality of your account credentials and for all activities that occur under your account.
            </p>
          </div>

          <div className='terms-section'>
            <h2>4. Purpose of Use</h2>
            <p>
              Uyirthunai is strictly a matrimonial platform intended to help individuals find a life partner. You agree
              to use our services solely for this lawful purpose — either for yourself or for an immediate family member
              on whose behalf you are legally authorized to act. Any misuse of the platform for commercial solicitation,
              fraud, harassment, or any unlawful activity is strictly prohibited.
            </p>
          </div>

          <div className='terms-section'>
            <h2>5. User Responsibilities</h2>

            <ul>
              <li>Provide only genuine and verifiable information in your profile.</li>
              <li>Do not impersonate any person or misrepresent your identity.</li>
              <li>Do not harass, abuse, or harm other members.</li>
              <li>Do not use the platform to share offensive, obscene, or inappropriate content.</li>
              <li>Comply with all applicable laws of Sri Lanka when using our services.</li>
            </ul>
          </div>

          <div className='terms-section'>
            <h2>6. Profile Content</h2>
            <p>
              You are solely responsible for all content you submit, including profile details, photographs, and
              messages. Uyirthunai reserves the right to review, edit, or remove any content that is found to be false,
              misleading, offensive, or in violation of these terms, without prior notice.
            </p>
          </div>

          <div className='terms-section'>
            <h2>7. Privacy</h2>
            <p>
              Your privacy is important to us. The collection, use, and protection of your personal information is
              governed by our Privacy Policy, which forms an integral part of these Terms & Conditions. Please review
              our Privacy Policy carefully.
            </p>
          </div>

          <div className='terms-section'>
            <h2>8. Payments & Subscriptions</h2>
            <p>
              Certain premium features of Uyirthunai require payment. By subscribing to any paid plan, you agree to pay
              all applicable fees. All payments are final and non-refundable unless otherwise stated in writing by
              Uyirthunai. We reserve the right to modify pricing with reasonable notice.
            </p>
          </div>

          <div className='terms-section'>
            <h2>9. Intellectual Property</h2>
            <p>
              All content on this platform, including but not limited to the name "Uyirthunai," logos, design elements,
              text, and graphics, is the exclusive intellectual property of Uyirthunai and is protected under applicable
              copyright and trademark laws. Unauthorized reproduction, distribution, or modification of any content is
              strictly prohibited.
            </p>
          </div>

          <div className='terms-section'>
            <h2>10. Disclaimer of Warranties</h2>
            <p>
              Uyirthunai provides its services on an "as is" and "as available" basis. We do not guarantee the accuracy
              or completeness of any user-submitted information, nor do we warrant that the platform will be
              uninterrupted, error-free, or free of viruses or other harmful components.
            </p>
          </div>

          <div className='terms-section'>
            <h2>11. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Uyirthunai and its directors, employees, and agents shall not be
              liable for any indirect, incidental, consequential, or punitive damages arising from your use of or
              inability to use the platform, including any loss resulting from reliance on user-provided information.
            </p>
          </div>

          <div className='terms-section'>
            <h2>12. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Uyirthunai, its officers, directors, employees, and partners from
              any claims, losses, damages, liabilities, or expenses (including legal fees) arising from your use of the
              platform, your content, or your violation of these Terms & Conditions.
            </p>
          </div>

          <div className='terms-section'>
            <h2>13. Termination</h2>
            <p>
              Uyirthunai reserves the right to suspend or permanently terminate your account at its sole discretion,
              without prior notice, if you are found to be in violation of these Terms & Conditions or engaged in any
              conduct harmful to the platform or its members.
            </p>
          </div>

          <div className='terms-section'>
            <h2>14. Changes to Terms</h2>
            <p>
              We reserve the right to update or modify these Terms & Conditions at any time. Continued use of the
              platform after any such changes constitutes your acceptance of the revised terms. We encourage you to
              review this page periodically.
            </p>
          </div>

          <div className='terms-section'>
            <h2>15. Governing Law</h2>
            <p>
              These Terms & Conditions shall be governed by and construed in accordance with the laws of Sri Lanka. Any
              disputes arising in connection with these terms shall be subject to the exclusive jurisdiction of the
              competent courts of Sri Lanka.
            </p>
          </div>

          <div className='terms-section'>
            <h2>Contact Us</h2>
            <p>
              For any questions or concerns regarding these Terms & Conditions, please contact us through our website or
              reach our support team directly.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndCondition;
